
export default () => ({
  isLoading: false,
  serviceLoaded: false,
  isCollectionLoading: false,
  aviatickets: {
    isLoading: false,
    hasError: false,
    searchId: null,
    current: {
      id: null,
      requestId: null,
      price: {
        amount: 0,
        markup: 0,
        currency: 'RUB'
      },
    },
    collection: [],
    errors: []
  },
  form: {
    cityFrom: {
      badge: null,
      code: null,
      slug: null,
      name: null
    },
    cityTo: {
      badge: null,
      code: null,
      slug: null,
      name: null
    },
    startDate: null,
    endDate: null,
    flightClass: 'ECONOMY',
    transfersCount: 0,
    currency: 'RUB',
    page: 1,
    perPage: 10,
    isRepeatedSearch: 0
  },
  quotasDates: {
    direction: [],
    reverseDirection: []
  },
  pagination: {
    page: 1,
    perPage: 10,
    lastPage: 1,
    total: 10
  }
})
